import { combineEpics, ofType } from 'redux-observable';
import { first, map, startWith, mergeMap } from 'rxjs/operators';

import { NOT_AUTHORIZED } from './actions';
import { actions } from '../auth';

const notAuthorizedEpic = action$ => action$.pipe(
  ofType(NOT_AUTHORIZED),
  mergeMap(({ failedAction }) => action$.pipe(
    ofType(actions.LOGIN_SUCCESS),
    first(),
    map(() => failedAction),
    startWith(actions.logoutSuccess()),
  )),
);

export default combineEpics(
  notAuthorizedEpic,
);
